import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../prop-types';
import CustomerUserStore from '../../../store/CustomerUserStore';
import UIStore from '../../../store/UIStore';
import PurchaseProduct from '../../../models/PurchaseProduct';
import globalTranslations from '../../../i18n/globalTranslations';
import ProductStore from '../../../store/ProductStore';
import MaybeExternalLink from '../../common/MaybeExternalLink';

const ProductHeaders = {
  product: <FormattedMessage {...globalTranslations.productTitle} />,
  count: <FormattedMessage {...globalTranslations.quantityTitle} />,
  withVat: <FormattedMessage {...globalTranslations.sumWithVat} />,
  withoutVat: <FormattedMessage {...globalTranslations.sumWithoutVat} />,
};

@observer
export class PurchaseProductItem extends Component {
  renderProductHeaderCol = (label, sizes) => {
    const actualSizes = Object.assign(
      {
        xs: 4,
      },
      sizes
    );
    return (
      <Col className="PurchaseProductItem__product-header" {...actualSizes}>
        {label}
      </Col>
    );
  };

  renderProductLink = () => {
    const { purchaseProduct } = this.props;

    if (purchaseProduct && purchaseProduct.url) {
      return (
        <MaybeExternalLink to={purchaseProduct.url}>
          {purchaseProduct.name}
        </MaybeExternalLink>
      );
    } else {
      return purchaseProduct.name;
    }
  };

  render() {
    const { purchaseProduct } = this.props;
    const { isMobile } = this.props.uiStore;
    if (!purchaseProduct) {
      return null;
    }

    return (
      <div className="PurchaseProductItem">
        <Row className="PurchaseProductItem__row">
          {isMobile && this.renderProductHeaderCol(ProductHeaders.product)}
          <Col xs="8" md="6">
            <div className="PurchaseProductItem__name">
              {this.renderProductLink()}
            </div>
          </Col>
          {isMobile && this.renderProductHeaderCol(ProductHeaders.count)}
          <Col xs="8" md="2">
            <div className="PurchaseProductItem__count">
              {purchaseProduct.total_qty}
            </div>
          </Col>
          {isMobile && this.renderProductHeaderCol(ProductHeaders.withVat)}
          <Col xs="8" md="2">
            <div
              className="PurchaseProductItem__sumWithVat"
              dangerouslySetInnerHTML={{
                __html: purchaseProduct.total_sum_with_tax,
              }}
            />
          </Col>
          {isMobile && this.renderProductHeaderCol(ProductHeaders.withoutVat)}
          <Col xs="8" md="2">
            <div
              className="PurchaseProductItem__sumWithoutVat"
              dangerouslySetInnerHTML={{
                __html: purchaseProduct.total_sum_without_tax,
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

PurchaseProductItem.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  productStore: modelOf(ProductStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  purchaseProduct: modelOf(PurchaseProduct),
};

export default inject(
  'customerUserStore',
  'productStore',
  'uiStore'
)(PurchaseProductItem);
